//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { fileLinkDownLoad, formatBytes, getFileType, isTypeImage } from '@/libs/public';
import imageViewer from '@/components/common/imageViewer';
export default {
  name: 'UploadList',
  props: {
    fileList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showClose: {
      type: Boolean,
      default: false
    }
  },
  components: {
    imageViewer: imageViewer
  },
  data: function data() {
    return {
      srcList: []
    };
  },
  watch: {
    fileList: {
      handler: function handler(nVal) {
        var _this = this;
        this.srcList = [];
        if (nVal.length > 0) {
          nVal.forEach(function (value) {
            if (isTypeImage(value.name)) {
              _this.srcList.push(value.file_url);
            }
          });
        }
      },
      immediate: true
    }
  },
  methods: {
    toSrcIcon: function toSrcIcon(name) {
      return getFileType(name);
    },
    toSizeFile: function toSizeFile(size) {
      return formatBytes(size);
    },
    fileDelete: function fileDelete(index) {
      this.fileList.splice(index, 1);
    },
    // 查看与下载附件
    lookViewer: function lookViewer(item) {
      var url = '';
      if (item.file_url) {
        url = item.file_url;
      }
      if (item.url) {
        url = item.url;
      }
      if (item.src) {
        url = item.src;
      }
      var name = item.name;
      if (isTypeImage(url)) {
        this.$refs.imageViewer.openImageViewer(url);
      } else {
        fileLinkDownLoad(url, name);
      }
    }
  }
};